import { render, staticRenderFns } from "./FacebookConnector.vue?vue&type=template&id=b671a4e0&"
import script from "./FacebookConnector.vue?vue&type=script&lang=js&"
export * from "./FacebookConnector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports